export default __webpack_public_path__ + "static/media/empty-folder.11eddc69.svg";